webpackJsonp([55702396619907],{

/***/ 420:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Chetan Arya's technology blog","facebook":{"appId":""}}},"allMarkdownRemark":{"group":[{"fieldValue":"sample","totalCount":1},{"fieldValue":"tag-1","totalCount":1},{"fieldValue":"tag-2","totalCount":1}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-5ab4a23a40a42df63d08.js